//获取cookie，参数name指定要获取的cookie的名称
export function getCookie(name) {
  var start = document.cookie.indexOf(name + "="); //得到cookie字符串中的名称
  var len = start + name.length + 1; //得到从起始位置到结束cookie位置的长度
  //如果起始没有值且name不存在于cookie字符串中，则返回null
  if ((!start) && (name != document.cookie.substring(0, name.length))) {
      return null;
  }
  if (start == -1) return null; //如果起始位置为-1也为null
  var end = document.cookie.indexOf(';', len); //获取cookie尾部位置
  if (end == -1) end = document.cookie.length; //计算cookie尾部长度
  return unescape(document.cookie.substring(len, end)); //获取cookie值
}

//删除cookie，必须先获取指定名称的cookie，然后让cookie过期
export function delCookie(name) {
  const path = '/';
  const domain = 'gmih.scimea.cn';
  if (getCookie(name)) {
    document.cookie = name + '=' + ((path) ? ';path=' + path : '') + ((domain) ? ';domain=' + domain : '') + ';expires=Thu, 01-Jan-1970 00:00:01 GMT';
  }
}